import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
// import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Helmet } from 'react-helmet';
import { updateIntl } from 'react-intl-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ScrollRoute } from './components/Analytics';

import RouterAnimation from './components/RouterAnimation/RouterAnimation';

import { CURRENT_PAGE } from './pages/SalonConsultationPage/localStorageKeys';

import GlobalMenu from './components/GlobalMenu';
import Footer from './components/Footer/Footer';
import BriefFooter from './components/Footer/BriefFooter';
import StylistHeader from './components/StylistHeader/StylistHeader';
import Auth from './components/Auth/Auth';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
// import PrivateRouteSc from './components/PrivateRoute/PrivateRouteSc';
import BreadCrumbMenu from './components/BreadCrumbMenus/';

import HairDiagnosisPage from './pages/HairDiagnosis/HairDiagnosisPage/HairDiagnosisPage';
import HairDiagnosisHomePage from './pages/HairDiagnosis/HairDiagnosisHomePage/HairDiagnosisHomePage';
import HairDiagnosisResultPage from './pages/HairDiagnosis/HairDiagnosisResultPage/HairDiagnosisResultPage';

import NewsAndEventsDetailsPage from './pages/NewsAndEventsDetailsPage/NewsAndEventsDetailsPage';
import SalonLocator from './pages/SalonLocator/SalonLocator';
import RootPage from './pages/RootPage';
import { ComingSoonPage, NotFoundpage, ErrorPage } from './pages/ErrorPage/errorPages';

import LoginPage from './pages/StylistToolPages/LoginPage/LoginPage';
import ForgotPasswordPage from './pages/StylistToolPages/ForgotPasswordPage/ForgotPasswordPage';
import ChangePasswordPage from './pages/StylistToolPages/ChangePasswordPage/ChangePasswordPage';
import SignUpPage from './pages/StylistToolPages/SignUpPage/SignUpPage';
import RetrieveProfilePage from './pages/StylistToolPages/RetrieveProfilePage/RetrieveProfilePage';
import ProfilePage from './pages/StylistToolPages/ProfilePage/ProfilePage';
import SalonVisitsPage from './pages/StylistToolPages/SalonVisitsPage/SalonVisitsPage';
import NewVisitPage from './pages/StylistToolPages/NewVisitPage/NewVisitPage';
import VisitSummaryPage from './pages/StylistToolPages/VisitSummaryPage/VisitSummaryPage';

import ScGlobalNav from './components/SalonConsultation/GlobalNavi/GlobalNavi';
import ScLoginPage from './pages/SalonConsultationPage/LoginPage/LoginPage';
import ScSignUpPage from './pages/SalonConsultationPage/SignUpPage/SignUpPage';
import ScForgotPasswordPage from './pages/SalonConsultationPage/ForgotPasswordPage/ForgotPasswordPage';
import ScChangePasswordPage from './pages/SalonConsultationPage/ChangePasswordPage/ChangePasswordPage';
import ScHomePage from './pages/SalonConsultationPage/HomePage/HomePage';
import ScSettingPage from './pages/SalonConsultationPage/SettingPage/SettingPage';
import ScSublimicHomePage from './pages/SalonConsultationPage/SublimicHomePage/SublimicHomePage';
import ScSublimicHomeCareListPage from './pages/SalonConsultationPage/SublimicHomeCareList/SublimicHomeCareList';
import ScSublimicHomeCareItemDetailPage from './pages/SalonConsultationPage/SublimicHomeCareItemDetailPage/SublimicHomeCareItemDetailPage';
import ScSublimicHomeCareStepPage from './pages/SalonConsultationPage/SublimicHomeCareStepPage/SublimicHomeCareStep';
import ScSublimicDiagnosisEmotionalPage from './pages/SalonConsultationPage/SublimicDiagnosisPage/EmotionalPage/EmotionalPage';
import ScSublimicDiagnosisUserSurveyPage from './pages/SalonConsultationPage/SublimicDiagnosisPage/UserSurveyPage/UserSurveyPage';
import ScSublimicDiagnosisScalpCameraPage from './pages/SalonConsultationPage/SublimicDiagnosisPage/ScalpCameraPage/ScalpCameraPage';
import ScSublimicDiagnosisStylistDiagnosisPage from './pages/SalonConsultationPage/SublimicDiagnosisPage/StylistDiagnosisPage/StylistDiagnosisPage';
import ScSublimicDiagnosisQuickDiagnosisPage from './pages/SalonConsultationPage/SublimicDiagnosisPage/QuickDiagnosisPage/QuickDiagnosisPage';
import ScSublimicDiagnosisResultPage from './pages/SalonConsultationPage/SublimicDiagnosisResultPage/SublimicDiagnosisResultPage';
// import ScSublimicDiagnosisResultTopPage from './pages/SalonConsultationPage/SublimicDiagnosisResultPage/TopPage/TopPage';
// import ScSublimicDiagnosisResultHairCarePage from './pages/SalonConsultationPage/SublimicDiagnosisResultPage/HairCarePage/HairCarePage';
// import ScSublimicDiagnosisResultScalpCarePage from './pages/SalonConsultationPage/SublimicDiagnosisResultPage/ScalpCarePage/ScalpCarePage';
// import ScSublimicDiagnosisResultConfirmPage from './pages/SalonConsultationPage/SublimicDiagnosisResultPage/ConfirmPage/ConfirmPage';
import ScSalonProgramPage from './pages/SalonConsultationPage/SalonProgramPage/SalonProgramPage';
import ScSalonProgramDetailPage from './pages/SalonConsultationPage/SalonProgramDetailPage/SalonProgramDetailPage';

import './pages/SalonConsultationPage/pageTransition.css';

import ExtraAMCADVolumeSerumPage from './pages/ExtraPage/AMCAD/VolumeSerum';
import ExtraAMCADScalpPowerShotPage from './pages/ExtraPage/AMCAD/ScalpPowerShot';
import ExtraAMCADShiseidoDiscoveryPage from './pages/ExtraPage/AMCAD/ShiseidoDiscovery';
import ExtraAMCADCorePowerrisingPage from './pages/ExtraPage/AMCAD/CorePowerrising';

import updateSiteOptions from './redux/actions/siteOptions';
import updateScreenSize from './redux/actions/updateScreenSize';
import updateSalonConsultaionSiteOptions from './redux/actions/salonConsultaionSiteOptions';
import salonSolutionList from './redux/actions/salonSolutionList';
import salonSetting from './redux/actions/salonSetting';
import homeCareItemList from './redux/actions/homeCareItemList';
import homeCareItemConcerns from './redux/actions/homeCareItemConcerns';
import userSurvey from './redux/actions/userSurvey';
import scalpCamera from './redux/actions/scalpCamera';
import stylistDiagnosis from './redux/actions/stylistDiagnosis';
import sublimicDiagnosisResult from './redux/actions/sublimicDiagnosisResult';
import sublimicDiagnosisLogics from './redux/actions/sublimicDiagnosisLogics';
import sublimicHome from './redux/actions/sublimicHome';
import customerRegistration from './redux/actions/customerRegistration';

import i18n from './i18n/i18n';

import './styles/normalize.css';
import './styles/index.css';
import './styles/font.style';
import './styles/global.style';
import { getScreenSize, throttle, errorLogger, lsSetItem, lsGetItem, lsRemoveItem } from './utils';

class App extends React.Component {
  static defaultProps = {
    salonLocatorEnabled: true,
  };

  static propTypes = {
    error: PropTypes.shape().isRequired,
    locale: PropTypes.string.isRequired,
    location: PropTypes.shape({}).isRequired,
    match: PropTypes.shape().isRequired,
    menu: PropTypes.shape({}).isRequired,
    salonLocatorEnabled: PropTypes.bool,
    screenSize: PropTypes.number.isRequired,
    updateError: PropTypes.func.isRequired,
    updateLocale: PropTypes.func.isRequired,
    updateIntl: PropTypes.func.isRequired,
    updateSiteOptions: PropTypes.func.isRequired,
    updateSalonConsultaionSiteOptions: PropTypes.func.isRequired,
    updateScreenSize: PropTypes.func.isRequired,
    sublimicHome: PropTypes.func.isRequired,
    homeCareItemList: PropTypes.func.isRequired,
    homeCareItemConcerns: PropTypes.func.isRequired,
    updateSalonSolutionList: PropTypes.func.isRequired,
    updateSalonSetting: PropTypes.func.isRequired,
    userSurvey: PropTypes.func.isRequired,
    scalpCamera: PropTypes.func.isRequired,
    stylistDiagnosis: PropTypes.func.isRequired,
    sublimicDiagnosisResult: PropTypes.func.isRequired,
    sublimicDiagnosisLogics: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.didLoadBeautyConsultation = false;
  }

  componentWillMount = () => {
    const { locale: oldLocale, match, updateIntl, updateLocale } = this.props;
    const { locale } = match.params;
    if (oldLocale !== locale) {
      updateLocale(locale);
    } else {
      if (window.location.pathname.indexOf('/salon-locator') < 0) {
        this.loadSiteOptions();
      }
      if (window.location.pathname.indexOf('/salon-consultation/') >= 0) {
        this.loadSalonConsultationSiteOptions();
        this.loadSalonSolutionList();
        this.loadUpdateSalonSetting();
        this.loadhomeCareItemList();
        this.loadhomeCareItemConcerns();
        this.loadUserSurvey();
        this.loadScalpCamera();
        this.loadStylistDiagnosis();
        this.loadSublimicDiagnosisResult();
        this.loadSublimicDiagnosisLogics();
        this.loadSublimicHome();
        this.loadCustomerRegistration();
      } else if (window.location.pathname.indexOf('/beauty-consultation') >= 0 && !this.didLoadBeautyConsultation) {
        this.loadSalonConsultationSiteOptions();
        this.loadUserSurvey();
        this.loadSalonSolutionList();
        this.loadhomeCareItemList();
        this.loadhomeCareItemConcerns();
        this.loadSublimicDiagnosisResult();
        this.loadSublimicDiagnosisLogics();
        this.loadStylistDiagnosis();
        this.didLoadBeautyConsultation = true;
      }
    }

    window.addEventListener('resize', this.handleScreenResize);
    this.handleScreenResize();

    updateIntl({
      locale,
      messages: i18n[locale],
    });
  };

  componentWillUpdate = () => {
    const path = window.location.pathname;
    lsSetItem(CURRENT_PAGE, path);
    if (path.indexOf('/beauty-consultation') >= 0 && !this.didLoadBeautyConsultation) {
      this.loadSalonConsultationSiteOptions();
      this.loadUserSurvey();
      this.loadSalonSolutionList();
      this.loadhomeCareItemList();
      this.loadhomeCareItemConcerns();
      this.loadSublimicDiagnosisResult();
      this.loadSublimicDiagnosisLogics();
      this.loadStylistDiagnosis();
      this.didLoadBeautyConsultation = true;
    }
  };

  componentDidUpdate = prevProps => {
    const { locale, menu } = this.props;
    const { locale: prevLocale } = prevProps;
    if (window.location.pathname.indexOf('/salon-locator') < 0 && !menu) {
      this.loadSiteOptions();
    }
    if (locale !== prevLocale) {
      this.loadSiteOptions();
      if (window.location.pathname.indexOf('/salon-consultation/') >= 0) {
        this.loadSalonConsultationSiteOptions();
        this.loadSalonSolutionList();
        this.loadUpdateSalonSetting();
        this.loadhomeCareItemList();
        this.loadhomeCareItemConcerns();
        this.loadScalpCamera();
        this.loadStylistDiagnosis();
        this.loadSublimicDiagnosisResult();
        this.loadSublimicDiagnosisLogics();
        this.loadSublimicHome();
        this.loadCustomerRegistration();
      } else if (window.location.pathname.indexOf('/beauty-consultation') >= 0 && !this.didLoadBeautyConsultation) {
        this.loadSalonConsultationSiteOptions();
        this.loadUserSurvey();
        this.loadSalonSolutionList();
        this.loadhomeCareItemList();
        this.loadhomeCareItemConcerns();
        this.loadSublimicDiagnosisResult();
        this.loadSublimicDiagnosisLogics();
        this.loadStylistDiagnosis();
        this.didLoadBeautyConsultation = true;
      }
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.handleScreenResize);
  };

  handleScreenResize = throttle(() => {
    const { screenSize, updateScreenSize } = this.props;
    const newScreenSize = getScreenSize();
    if (newScreenSize !== screenSize) updateScreenSize(newScreenSize);
  });

  loadSiteOptions = () => {
    const { locale, updateError, updateSiteOptions } = this.props;

    updateSiteOptions(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  loadSalonConsultationSiteOptions = () => {
    const { locale, updateError, updateSalonConsultaionSiteOptions } = this.props;

    updateSalonConsultaionSiteOptions(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  loadSalonSolutionList = () => {
    const { locale, updateError, updateSalonSolutionList } = this.props;
    updateSalonSolutionList(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  loadUpdateSalonSetting = () => {
    const { locale, updateError, updateSalonSetting } = this.props;
    updateSalonSetting(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  loadhomeCareItemList = () => {
    const { locale, updateError, homeCareItemList } = this.props;

    homeCareItemList(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  loadhomeCareItemConcerns = () => {
    const { locale, updateError, homeCareItemConcerns } = this.props;

    homeCareItemConcerns(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadUserSurvey = () => {
    const { locale, updateError, userSurvey } = this.props;
    userSurvey(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadSublimicHome = () => {
    const { locale, updateError, sublimicHome } = this.props;

    sublimicHome(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadScalpCamera = () => {
    const { locale, updateError, scalpCamera } = this.props;
    scalpCamera(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadStylistDiagnosis = () => {
    const { locale, updateError, stylistDiagnosis } = this.props;
    stylistDiagnosis(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadSublimicDiagnosisResult = () => {
    const { locale, updateError, sublimicDiagnosisResult } = this.props;
    sublimicDiagnosisResult(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadSublimicDiagnosisLogics = () => {
    const { locale, updateError, sublimicDiagnosisLogics } = this.props;
    sublimicDiagnosisLogics(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  loadCustomerRegistration = () => {
    const { locale, updateError, customerRegistration } = this.props;
    customerRegistration(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  render = () => {
    const { error, locale, salonLocatorEnabled, location } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <meta property="og:locale" content={locale} />
        </Helmet>

        <Switch>
          <Route
            path="/:locale/salon-consultation"
            render={() => (
              <Helmet>
                <link rel="manifest" href="/manifest_sc.json" />
                <link rel="apple-touch-icon" href="/HairBeautyPro.png" />
                <meta name="apple-mobile-web-app-capable" content="yes" />
                {/* <link rel="apple-touch-startup-image" href="/splash/launch-1536x2048.png" media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" />
                <link rel="apple-touch-startup-image" href="/splash/launch-1536x2048.png" media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" />
                <link rel="apple-touch-startup-image" href="/splash/launch-1536x2048.png" media="(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" />
                <link rel="apple-touch-startup-image" href="/splash/launch-1536x2048.png" media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" /> */}
                <link rel="apple-touch-startup-image" media="(min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)"　href="/splash/launch-1536x2048.png" />
                {/* <link rel="apple-touch-startup-image" href="/splash/launch-1536x2048.png" media="(min-device-width: 834px) and (max-device-width: 834px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)" />
                <link rel="apple-touch-startup-image" href="/splash/launch-1536x2048.png" media="(min-device-width: 1024px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)" /> */}
              </Helmet>
            )}
          />
          <Route
            path="/:locale/"
            render={() => (
              <Helmet>
                <link rel="manifest" href="/manifest.json" />
              </Helmet>
            )}
          />
        </Switch>

        <Auth />
        <Route path="/" component={ScrollRoute} />

        <Switch>
          <Route path="/:locale/salon-locator" component={props => <GlobalMenu onlyLogo {...props} />} />
          <Route path="/:locale/beauty-consultation" component={props => <GlobalMenu onlyLogo {...props} />} />
          <Route path="/:locale/seminar-schedule" exact component={props => <GlobalMenu white {...props} />} />
          <Route path="/:locale/education/:seminar" exact component={props => <GlobalMenu white {...props} />} />
          <Route path="/:locale/stylist/:pageType" component={StylistHeader} />
          <Route path="/:locale/salon-consultation/:pageType" component={ScGlobalNav} />
          <Route path="/:locale/extra-SMCAD_howto_volumeserum" />
          <Route path="/:locale/extra-SMCAD_hotwo_scalppowershot" />
          <Route path="/:locale/extra-SMCAD_shiseidodiscovery" />
          <Route path="/:locale/extra-SMCAD_corepowerrising" />
          <Route component={props => <GlobalMenu {...props} />} />
        </Switch>

        <Switch>
          {error.id && <Route component={() => <ErrorPage {...error} />} />}

          <Route path="/:locale/news-and-events/:slug" component={NewsAndEventsDetailsPage} />

          <Route path="/:locale/salon-locator" exact component={SalonLocator} />

          <Route path="/:locale/beautyforyou" exact component={HairDiagnosisPage} />
          <Route path="/ja_jp/beauty-consultation" exact component={() => {
            window.location.href = 'https://chatbot.intelliticks.com/landing/mA8zPyJSZRafDqJwv_c/playbook/614573b59fb5be0a5c02a248';
            return null;
          }} />
          <Route path="/ja_jp/beauty-consultation/results/:id?" component={() => {
            window.location.href = 'https://chatbot.intelliticks.com/landing/mA8zPyJSZRafDqJwv_c/playbook/614573b59fb5be0a5c02a248';
            return null;
          }} />
          <Route path="/:locale/beauty-consultation" exact component={() => {
            window.location.href = 'https://chatbot.intelliticks.com/landing/XByh3mHYmNimgTwgN_c/playbook/60a26bd7380d7b473045da2a';
            return null;
          }} />
          <Route path="/:locale/beauty-consultation/results/:id?" component={() => {
            window.location.href = 'https://chatbot.intelliticks.com/landing/XByh3mHYmNimgTwgN_c/playbook/60a26bd7380d7b473045da2a';
            return null;
          }} />

          <Route path="/:locale/stylist/login" exact component={LoginPage} />
          <Route path="/:locale/stylist/forgot-password" exact component={ForgotPasswordPage} />
          <Route path="/:locale/stylist/change-password" exact component={ChangePasswordPage} />
          <Route path="/:locale/stylist/sign-up" exact component={SignUpPage} />

          <Route path="/:locale/stylist" exact render={() => <Redirect to={`/${locale}/stylist/login`} />} />
          <PrivateRoute path="/:locale/stylist/retrieve-profile" exact component={RetrieveProfilePage} />
          <PrivateRoute path="/:locale/stylist/profile" exact component={ProfilePage} />
          <PrivateRoute path="/:locale/stylist/visits" exact component={SalonVisitsPage} />
          <PrivateRoute path="/:locale/stylist/new-visit" exact component={NewVisitPage} />
          <PrivateRoute path="/:locale/stylist/visit/:id?" component={VisitSummaryPage} />

          <Route path="/:locale/coming-soon" exact component={ComingSoonPage} />

          {!salonLocatorEnabled && <Route path="/:locale/salon-locator" exact component={ComingSoonPage} />}
          <Route
            path="/:locale/salon-consultation"
            render={() => (
              <div id="salon-consultation-wrapper">
                <Route path="/:locale/salon-consultation/sublimic" component={() => <div style={{ position: "fixed", zIndex: -1, backgroundImage: "url(/SMC_background.png)" , backgroundPosition: "center", width: "100vw", height: "100vh" }} />} />
                <Switch>
                  <Route path="/:locale/salon-consultation/login" exact component={ScLoginPage} />
                  <RouterAnimation>
                    <Route path="/:locale/salon-consultation/sign-up" exact component={ScSignUpPage} />
                    <Route path="/:locale/salon-consultation/forgot-password" exact component={ScForgotPasswordPage} />
                    <Route path="/:locale/salon-consultation/change-password" exact component={ScChangePasswordPage} />
                    <PrivateRoute path="/:locale/salon-consultation/home" exact component={ScHomePage} />
                    <PrivateRoute path="/:locale/salon-consultation/setting" exact component={ScSettingPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/home" exact component={ScSublimicHomePage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/homecare" exact component={ScSublimicHomeCareListPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/homecare/:slug" exact component={ScSublimicHomeCareItemDetailPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/homecare/:slug/step" exact component={ScSublimicHomeCareStepPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/salon-program" exact component={ScSalonProgramPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/salon-program/:slug" exact component={ScSalonProgramDetailPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/diagnosis" exact component={ScSublimicDiagnosisEmotionalPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/diagnosis/user-survey" exact component={ScSublimicDiagnosisUserSurveyPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/diagnosis/scalp-camera" exact component={ScSublimicDiagnosisScalpCameraPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/diagnosis/stylist-diagnosis" exact component={ScSublimicDiagnosisStylistDiagnosisPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/diagnosis/quick-diagnosis" exact component={ScSublimicDiagnosisQuickDiagnosisPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/diagnosis/result/top" exact component={ScSublimicDiagnosisResultPage} />
                    {/* <PrivateRoute path="/:locale/salon-consultation/sublimic/diagnosis/result/top" exact component={ScSublimicDiagnosisResultTopPage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/diagnosis/result/hair-care" exact component={ScSublimicDiagnosisResultHairCarePage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/diagnosis/result/scalp-care" exact component={ScSublimicDiagnosisResultScalpCarePage} />
                    <PrivateRoute path="/:locale/salon-consultation/sublimic/diagnosis/result/confirm" exact component={ScSublimicDiagnosisResultConfirmPage} /> */}
                    <PrivateRoute path="/:locale/salon-consultation/customer/search" exact render={() => <Redirect to={`/${locale}/salon-consultation/home`} />} />
                    <PrivateRoute path="/:locale/salon-consultation/customer/regist" exact render={() => <Redirect to={`/${locale}/salon-consultation/home`} />} />
                    <PrivateRoute path="/:locale/salon-consultation/customer/top" exact render={() => <Redirect to={`/${locale}/salon-consultation/home`} />} />
                  </RouterAnimation>
                </Switch>
              </div>
            )}
          />

          <Route path="/:locale/extra-SMCAD_howto_volumeserum" exact component={ExtraAMCADVolumeSerumPage} />
          <Route path="/:locale/extra-SMCAD_hotwo_scalppowershot" exact component={ExtraAMCADScalpPowerShotPage} />
          <Route path="/:locale/extra-SMCAD_shiseidodiscovery" exact component={ExtraAMCADShiseidoDiscoveryPage} />
          <Route path="/:locale/extra-SMCAD_corepowerrising" exact component={ExtraAMCADCorePowerrisingPage} />

          <Route path="/:locale" exact component={RootPage} />
          <Route path="/:locale/:lvl1" exact component={RootPage} />
          <Route path="/:locale/:lvl1/:lvl2" exact component={RootPage} />
          <Route path="/:locale/:lvl1/:lvl2/:lvl3" exact component={RootPage} />

          <Route component={NotFoundpage} />
        </Switch>

        {/* パンくずリスト */}
        {!!(location.pathname === `/${locale}` || location.pathname === `/${locale}/`) && (
          <Route
            component={() => (
              <BreadCrumbMenu
                currentPath={`https://www.shiseido-professional.com/${locale}`}
                items={[
                  {
                    name: 'TOP',
                    path: null,
                  },
                ]}
              />
            )}
          />
        )}

        <Switch>
          <Route path="/:locale/stylist" component={null} />
          <Route path="/:locale/salon-locator" component={BriefFooter} />
          <Route path="/:locale/beauty-consultation" component={BriefFooter} />
          <Route path="/:locale/salon-consultation/:pageType" />
          <Route path="/:locale/extra-SMCAD_howto_volumeserum" />
          <Route path="/:locale/extra-SMCAD_hotwo_scalppowershot" />
          <Route path="/:locale/extra-SMCAD_shiseidodiscovery" />
          <Route path="/:locale/extra-SMCAD_corepowerrising" />
          <Route component={() => <Footer />} />
        </Switch>
      </React.Fragment>
    );
  };
}

const mapState = state => ({
  intl: state.intl,
  locale: state.locale,
  screenSize: state.screenSize,
  salonLocatorEnabled: state.siteOptions.salonLocatorEnabled,
  menu: state.siteOptions.menu,
  error: state.error,
});

const mapDispatch = dispatch => ({
  updateError: error => dispatch({ type: 'UPDATE_ERROR', error }),
  updateIntl: intl => dispatch(updateIntl(intl)),
  updateSiteOptions: locale => dispatch(updateSiteOptions(locale)),
  updateSalonConsultaionSiteOptions: locale => dispatch(updateSalonConsultaionSiteOptions(locale)),
  updateSalonSolutionList: locale => dispatch(salonSolutionList(locale)),
  updateSalonSetting: locale => dispatch(salonSetting(locale)),
  homeCareItemList: locale => dispatch(homeCareItemList(locale)),
  homeCareItemConcerns: locale => dispatch(homeCareItemConcerns(locale)),
  userSurvey: locale => dispatch(userSurvey(locale)),
  scalpCamera: locale => dispatch(scalpCamera(locale)),
  stylistDiagnosis: locale => dispatch(stylistDiagnosis(locale)),
  sublimicDiagnosisResult: locale => dispatch(sublimicDiagnosisResult(locale)),
  sublimicDiagnosisLogics: locale => dispatch(sublimicDiagnosisLogics(locale)),
  updateScreenSize: screenSize => dispatch(updateScreenSize(screenSize)),
  updateLocale: locale => dispatch({ type: 'UPDATE_LOCALE', locale }),
  sublimicHome: locale => dispatch(sublimicHome(locale)),
  customerRegistration: locale => dispatch(customerRegistration(locale)),
});

export default connect(mapState, mapDispatch)(App);



// WEBPACK FOOTER //
// ./src/App.js